export default "__VITE_ASSET__84421fd6__"